import { useParamsSearch } from '@anytag/shared-hooks';
import { ReportSearchSchemaType } from '../schema-types';

export const useReportFilter = () => useParamsSearch<ReportSearchSchemaType>();
